import config from '~/config';

export interface TrainingModule {
  key: string;
  cmid: number;
  path: string;
  pathMode: string;
}

export const getModuleIDByKey = (key: string): number => {
  let match = -1;
  if (config.modules) {
    for (const module of config.modules) {
      if (module.key === key) {
        match = module.cmid;
        break;
      }
    }
  }
  return match;
}

export const getModuleByKey = (key: string): (TrainingModule | undefined) => {
  if (config.modules) {
    for (const module of config.modules) {
      if (module.key === key) {
        return module;
      }
    }
  }
  return undefined;
}

export const getModuleByCMID = (cmid: number): (TrainingModule | undefined) => {
  if (config.modules) {
    for (const module of config.modules) {
      if (module.cmid === cmid) {
        return module;
      }
    }
  }
  return undefined;
}


// WEBPACK FOOTER //
// ./src/utils/trainingModules.ts